(() => {
  if (window.DarPrirodeQuizLazyLoaderInitialized) return;
  window.DarPrirodeQuizLazyLoaderInitialized = true;

  const loads = new Map();

  const sectionIdFromOpener = (opener) => {
    const controlled = opener.getAttribute('aria-controls') || '';
    if (controlled.startsWith('DarPrirodeQuiz-')) {
      return controlled.replace('DarPrirodeQuiz-', '');
    }

    const hero = opener.closest('[data-dp-hero-root]');
    return hero?.id?.replace('DarPrirodeHero-', '') || '';
  };

  const findTemplate = (sectionId) => {
    if (!sectionId) return document.querySelector('template[data-dp-quiz-template]');
    return document.querySelector(
      `template[data-dp-quiz-template][data-section-id="${CSS.escape(sectionId)}"]`
    );
  };

  const loadStyle = (url) => {
    if (!url) return Promise.resolve();
    const existing = [...document.styleSheets].some((sheet) => sheet.href === url) ||
      document.querySelector(`link[data-dp-quiz-lazy-style][href="${CSS.escape(url)}"]`);
    if (existing) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.dataset.dpQuizLazyStyle = 'true';
      link.onload = resolve;
      link.onerror = () => reject(new Error('Quiz CSS nije učitan.'));
      document.head.appendChild(link);
    });
  };

  const loadScript = (url) => {
    if (!url || window.DarPrirodeQuizScriptLoaded) return Promise.resolve();
    const existing = document.querySelector(`script[data-dp-quiz-lazy-script][src="${CSS.escape(url)}"]`);
    if (existing) {
      return new Promise((resolve, reject) => {
        if (window.DarPrirodeQuizScriptLoaded) return resolve();
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
      });
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.dataset.dpQuizLazyScript = 'true';
      script.onload = () => {
        window.DarPrirodeQuizScriptLoaded = true;
        resolve();
      };
      script.onerror = () => reject(new Error('Quiz JavaScript nije učitan.'));
      document.head.appendChild(script);
    });
  };

  const instantiateQuiz = (template, sectionId) => {
    let quiz = document.getElementById(`DarPrirodeQuiz-${sectionId}`);
    if (quiz) return quiz;

    const fragment = template.content.cloneNode(true);
    quiz = fragment.querySelector('[data-dp-quiz]');
    template.parentNode.insertBefore(fragment, template.nextSibling);
    return document.getElementById(`DarPrirodeQuiz-${sectionId}`) || quiz;
  };

  const loadCatalog = async (quiz, url) => {
    const target = quiz?.querySelector('[data-dp-quiz-catalog]');
    if (!target || target.dataset.loaded === 'true') return;

    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!response.ok) {
      throw new Error(`Quiz katalog nije učitan (${response.status}).`);
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fragment = doc.querySelector('[data-dp-quiz-catalog-fragment]');

    if (!fragment) throw new Error('Quiz katalog nema očekivani sadržaj.');

    target.replaceChildren(...fragment.cloneNode(true).childNodes);
    target.dataset.loaded = 'true';
  };

  const ensureLoaded = async (opener) => {
    const sectionId = sectionIdFromOpener(opener);
    if (!sectionId) throw new Error('Nije pronađen ID hero sekcije.');

    if (loads.has(sectionId)) return loads.get(sectionId);

    const promise = (async () => {
      const template = findTemplate(sectionId);
      if (!template) throw new Error('Nije pronađen lazy quiz template.');

      const quiz = instantiateQuiz(template, sectionId);
      opener.setAttribute('aria-busy', 'true');
      opener.dataset.quizLoading = 'true';

      await Promise.all([
        loadStyle(template.dataset.quizCssUrl),
        loadCatalog(quiz, template.dataset.quizCatalogUrl)
      ]);

      await loadScript(template.dataset.quizJsUrl);

      opener.removeAttribute('aria-busy');
      delete opener.dataset.quizLoading;

      return { quiz, sectionId };
    })().catch((error) => {
      loads.delete(sectionId);
      opener.removeAttribute('aria-busy');
      delete opener.dataset.quizLoading;
      console.error('[Dar Prirode lazy quiz]', error);
      throw error;
    });

    loads.set(sectionId, promise);
    return promise;
  };

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-dp-quiz-open]');
    if (!opener) return;

    const sectionId = sectionIdFromOpener(opener);
    const activeQuiz = sectionId
      ? document.getElementById(`DarPrirodeQuiz-${sectionId}`)
      : document.querySelector('[data-dp-quiz]');

    if (window.DarPrirodeQuizScriptLoaded && activeQuiz?._dpQuizController) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    try {
      const loaded = await ensureLoaded(opener);
      document.dispatchEvent(new CustomEvent('dp:quiz:open', {
        detail: {
          sectionId: loaded.sectionId,
          opener,
          mode: opener.dataset.quizMode || 'all',
          prefill: opener.dataset.quizPrefill || ''
        }
      }));
    } catch (_) {
      opener.removeAttribute('aria-busy');
    }
  }, true);

  window.DarPrirodeQuizLazy = {
    version: '1.0.0',
    ensureLoaded
  };
})();
